type PagamentoTipo = {
    codigo:number;
    nome:string;
}

export enum EnumPagamentoTipo {
    Credito = 1,
    Pix,
    Boleto,
    Debito
}

export default PagamentoTipo;